import React from 'react';
import {
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Slide,
  Box,
} from '@mui/material';
import { MinimizeOutlined } from '@mui/icons-material';
import { useClinicalSession } from '../../contexts/ClinicalSessionContext';
import ClinicalSession from './index';
import SavingProgressIndicator from './SavingProgressIndicator';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

const ClinicalSessionDialog = () => {
  const { getAllSessions, minimizeSession, closeSession } =
    useClinicalSession();

  const allSessions = getAllSessions();
  const openSessions = allSessions.filter(
    (session) => session.isOpen && !session.isMinimized
  );

  const formatName = (name) => {
    if (!name) return 'Unnamed Patient';
    return name;
  };

  // Get sessions that are currently saving
  const savingSessions = allSessions.filter((session) => session.isSaving);

  return (
    <>
      {/* Render normal dialogs for non-saving sessions */}
      {openSessions
        .filter((session) => !session.isSaving)
        .map((session) => (
          <Dialog
            key={session.id}
            fullScreen
            open={true}
            onClose={(event, reason) => {
              if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
                minimizeSession(session.id);
              }
            }}
            TransitionComponent={Transition}
            disableEscapeKeyDown={false}
            sx={{
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
          >
            <AppBar sx={{ position: 'relative', bgcolor: '#9291ef' }}>
              <Toolbar>
                <Typography sx={{ flex: 1 }} variant='h6' component='div'>
                  Clinical Session - {formatName(session.sessionData.userName)}
                </Typography>

                <IconButton
                  edge='end'
                  color='inherit'
                  onClick={() => minimizeSession(session.id)}
                  aria-label='minimize'
                  title='Minimize'
                >
                  <MinimizeOutlined />
                </IconButton>
              </Toolbar>
            </AppBar>
            <Box
              sx={{
                p: 3,
                bgcolor: '#f8f9fa',
                minHeight: '100vh',
                overflowY: 'auto',
              }}
            >
              <ClinicalSession
                sessionId={session.id}
                user={session.sessionData.user}
                userName={session.sessionData.userName}
              />
            </Box>
          </Dialog>
        ))}

      {/* Render saving sessions in hidden container to keep components mounted */}
      {openSessions
        .filter((session) => session.isSaving)
        .map((session) => (
          <Box
            key={session.id}
            sx={{
              position: 'absolute',
              left: '-9999px',
              top: '-9999px',
              width: '1px',
              height: '1px',
              overflow: 'hidden',
              pointerEvents: 'none',
              visibility: 'hidden',
            }}
          >
            <ClinicalSession
              sessionId={session.id}
              user={session.sessionData.user}
              userName={session.sessionData.userName}
            />
          </Box>
        ))}

      {/* Show draggable progress indicators for saving sessions */}
      {savingSessions.map((session) => (
        <SavingProgressIndicator
          key={session.id}
          sessionId={session.id}
          userName={formatName(session.sessionData.userName)}
        />
      ))}
    </>
  );
};

export default ClinicalSessionDialog;
